/**
 * Icons mapping — mirrors `getNodeIcon` from
 * `apps/frontend-next/src/ui/utils/productionEditor.ts`.
 *
 * Same SVG assets, copied at-rest into the kit so any prototype can use
 * `getNodeIcon(entityName)` without depending on the live Nemo repo.
 *
 * Add here any new entityName the prototype needs.
 */
import boilerIcon from '../icons/boiler.svg';
import chillerIcon from '../icons/chiller.svg';
import coolingTowerIcon from '../icons/cooling_tower.svg';
import departureIcon from '../icons/departure.svg';
import fuelIcon from '../icons/fuel.svg';
import pollutantIcon from '../icons/pollutant.svg';
import powerIcon from '../icons/power.svg';
import pumpIcon from '../icons/pump.svg';
import returnIcon from '../icons/return.svg';
import waterIcon from '../icons/water.svg';
import waterCoolingIcon from '../icons/water_cooling.svg';
import waterStorageIcon from '../icons/water_storage.svg';

const ICONS: Record<string, string> = {
    Boiler: boilerIcon,
    boiler: boilerIcon,
    SteamProductionUnit: boilerIcon,
    Chiller: chillerIcon,
    chiller: chillerIcon,
    CoolingTower: coolingTowerIcon,
    cooling_tower: coolingTowerIcon,
    Departure: departureIcon,
    departure: departureIcon,
    Return: returnIcon,
    return: returnIcon,
    FuelContract: fuelIcon,
    fuel_contract: fuelIcon,
    Fuel: fuelIcon,
    PollutantContract: pollutantIcon,
    pollutant_contract: pollutantIcon,
    PowerContract: powerIcon,
    power_contract: powerIcon,
    PumpGroup: pumpIcon,
    pump_group: pumpIcon,
    HotWaterCollectorPumpGroup: pumpIcon,
    VariableSpeedPump: pumpIcon,
    variable_speed_pump: pumpIcon,
    ProductionVariableSpeedPump: pumpIcon,
    FixedSpeedPump: pumpIcon,
    fixed_speed_pump: pumpIcon,
    WaterContract: waterIcon,
    water_contract: waterIcon,
    WaterCooling: waterCoolingIcon,
    water_cooling: waterCoolingIcon,
    WaterStorage: waterStorageIcon,
    water_storage: waterStorageIcon,
    Tank: waterStorageIcon,
    HotWaterCollector: waterStorageIcon,
    hot_water_collector: waterStorageIcon,
    Collector: waterStorageIcon,
    SteamCollector: waterStorageIcon,
    StorageTank: waterStorageIcon,
    storage_tank: waterStorageIcon,
};

export function getNodeIcon(entityName: string): string | undefined {
    // Cf. real impl: Return uses Departure icon (arrow direction).
    if (entityName === 'Return') return ICONS.Departure;
    return ICONS[entityName];
}

/** Entity types that render as a flat read-only label (Tank, Collector, …). */
export const READ_ONLY_NODE_TYPES = [
    'WaterStorage',
    'water_storage',
    'HotWaterCollector',
    'hot_water_collector',
    'SteamCollector',
    'Tank',
    'Collector',
];
